import React, { useState, useEffect } from 'react';
import { Card } from 'antd-mobile';
import { Empty, Loading } from '../components';
import Trend from '../components/Trend';

import moment from 'moment';
import { DescribeSendStatistics } from "../../../api/usms";
import { timeFormatType, renderDateRange, renderDate } from '../utils/timeFormat';
import { getSthousandsFormatNum } from '../utils/common';

/**
 * 发送数据趋势图，时间范围来自发送数据总览
 * 获取时间维度数据
 */
function SendDataTrend(props) {
    const { dates } = props;

    const [dateStatistics, setDateStatistics] = useState([]);
    const [dateLoading, setDateLoading] = useState(false);

    useEffect(() => {
        if (dates) {
            getSendStatistics(dates);
        }
        // eslint-disable-next-line
    }, [dates]);

    const getSendStatistics = (dates) => {
        setDateLoading(true);
        const data = {
            BeginTime: moment(dates[0]).unix(),
            EndTime: moment(dates[1]).unix(),
            GroupCondition: ["SendDate"]
        }
        DescribeSendStatistics(data).then(res => {
            setDateStatistics(getTrendData(res));
            setDateLoading(false);
        })
    }

    const getTrendData = (list) => {
        const sortList = list.sort(function (a, b) {
            return moment(a.SendDate).unix() - moment(b.SendDate).unix();
        })
        const success = getSerieList(sortList, "SuccessCostCount", "发送成功")
        const failed = getSerieList(sortList, "FailedCostCount", "发送失败")
        const unknown = getSerieList(sortList, "UnKnownCostCount", "状态未知")
        const total = getSerieList(sortList, "TotalCostCount", "发送总数")

        const data = [...total, ...success, ...failed, ...unknown];

        return data
    }

    // 获取发送总量
    const getSerieList = (statistics, key, serie) => {
        const list = statistics.map(item => {
            return {
                SendDate: renderDate(item.SendDate, timeFormatType.date),
                Value: item[key],
                Serie: serie
            }
        });

        return list
    }

    return <Loading loading={dateLoading}>
        <Card>
            <Card.Body>
                <div style={{ marginBottom: '10px' }}>
                    <span style={{ fontWeight: "bold" }}>{`${"发送趋势"} `}</span>
                    {dates ? renderDateRange(dates, timeFormatType.date_xg) : ""}
                </div>
                {dateStatistics && dateStatistics.length > 0 ?
                    <Trend
                        data={dateStatistics}
                        xField="SendDate"
                        yField="Value"
                        seriesField="Serie"
                        yAxis={{
                            label: {
                                formatter: (v) => `${getSthousandsFormatNum(v)} 条`,
                            },
                        }}
                        tooltip={{
                            formatter: (datum) => {
                                return { name: datum.Serie, value: `${getSthousandsFormatNum(datum.Value)} 条` };
                            },
                        }}
                    /> :
                    <Empty />
                }
            </Card.Body>
        </Card>
    </Loading>
}
export default SendDataTrend